import React, { useRef, useState } from 'react';
import './Contact.css';
import { MdOutlineEmail } from 'react-icons/md';
import { BsWhatsapp } from 'react-icons/bs';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import emailjs from '@emailjs/browser';
// service ID is service_6gdoq4h
// tamplet ID is template_y6oozzb
// public key is dI0Q5RCp8IYVTqL5p
// the website is https://dashboard.emailjs.com/admin

const Contact = () => {
  const form = useRef();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleFormSubmit = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_6gdoq4h', 'template_y6oozzb', form.current, 'dI0Q5RCp8IYVTqL5p')
      .then(() => {
        toast.success('Message sent successfully!');
        setName('');
        setEmail('');
        setMessage('');
      })
      .catch(() => {
        toast.error('Failed to send message. Please try again later.');
      });
  };

  return (
    <section id="contact">
      <div className="section__wrapper contact__container">
        <div className="section__header">
          <h2 className="primary__title">Contact Me</h2>
          <p className="text__muted description">
          Are you eager to elevate your online presence? Whether you seek to launch, revamp, or explore new opportunities for your website or business, count on me for assistance. Contact me today to discuss your project, inquire, or simply say hello.


          </p>
        </div>
        <div className="contact__group">
          <div className="contact__options">
            <article className="contact__option">
              <MdOutlineEmail className="contact__icon" />
              <h3>Email</h3>
              <h3>yassin.al.farwan@gmail.com</h3>
              <a href="mailto:yassin.al.farwan@gmail.com" target="_blank" rel="noopener noreferrer" className="btn">
                Send a message
              </a>
            </article>
            <article className="contact__option">
              <BsWhatsapp className="contact__icon" />
              <h3>WhatsApp</h3>
              <h3>+962 798035955</h3>
              <a
                href="https://api.whatsapp.com/send?phone=+962798035955"
                target="_blank"
                rel="noopener noreferrer"
                className="btn"
              >
                Send a message
              </a>
            </article>
          </div>
          <form ref={form} onSubmit={handleFormSubmit}>
            <input
              type="text"
              name="from_name"
              placeholder="Your full name"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <input
              type="email"
              name="from_name"
              placeholder="Your Email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <textarea
              name="message"
              rows={7}
              placeholder="Your Message"
              required
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
            <button type="submit" className="btn btn__primary">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;